module.exports = __webpack_public_path__ + "media/customizations/meridiana/back-11d540509189f12ef897104c52cea2fa.jpg";